import { render, staticRenderFns } from "./AsociarFlotas.vue?vue&type=template&id=181c18c2&"
import script from "./AsociarFlotas.vue?vue&type=script&lang=ts&"
export * from "./AsociarFlotas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports